/**
 * Ton aus der nativen Hülle kommt als base64 über die Brücke. (24.09.2026)
 *
 * ⚠️ Bis heute stand diese Funktion privat in ptt.ts (native Sprechtaste,
 *    05.09.). Seit Ticket 2536 bringt auch das Wach-Wort seinen Satz so mit —
 *    eine zweite Kopie daneben wäre das Muster, das hier schon oft genug
 *    auseinandergelaufen ist.
 *
 * Wirft bei kaputtem base64 (`atob`) — der Aufrufer entscheidet, was dann gilt.
 */
export function base64ZuBlob(b64: string, mime: string): Blob {
  const bin = atob(b64);
  const u8 = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
  return new Blob([u8], { type: mime });
}
